"use strict";

/**
 * Desktop banner on the top-right side of the pornstars list
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled
    /** Desktop only */ && FlixUtils.isDesktop()
    /** pornstars index page */ && !!document.querySelector('#pornstarsAD');
  }
  ;

  /**
   * Main logic
   */
  function onPageLoad() {
    if (!isEnabled()) {
      return;
    }
    var el = document.querySelector('#pornstarsAD');
    if (Flix.isTna()) {
      FlixUtils.renderBannerAd(4505224, el, 'eas6a97888e38', 'ad_error_ntv1');
    } else {
      FlixUtils.renderBannerAd(4505290, el, 'eas6a97888e38', 'ad_error_ntv1');
    }
  }
  ;
})();